$(document).ready(function(){
    $('button.menu-drawer__item-link-arrow').attr('aria-label','Open submenu');
    $('button.menu-drawer__item-link-arrow.button-unstyled.flex.items-center.justify-center.cursor-pointer').attr('aria-label','Open submenu');
$('button.cart-drawer__close.dialog__close').attr('aria-label','Close cart drawer');
$('a[href="/products/protein-sips-vitamins-kids"]').attr('aria-label','View product Protein Sips Vitamins for Kids');

setTimeout(() => {
    $("div.product-badges.product-badges--vertical span.badge.badge--sale").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

  
}, 1000);

let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if (  $("button.taspect-ratio--object.to-0.tpointer.tz-2").length) {


      $("button.taspect-ratio--object.to-0.tpointer.tz-2").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  $("button.rb-btn.rb-btn-qty.rb-btn-qty-plus span.tw1").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });


        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}



let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$("img[src=\"//sipsclub.com/cdn/shop/files/third_party_tested_2ad787da-2477-432d-a863-2d5579728251.png?v=1777116182&width=300\"]").attr("alt", "Document with checkmark on a page and test tube");
$("img[src=\"//sipsclub.com/cdn/shop/files/no_artificial_dyes.png?v=1776250206&width=300\"]").attr("alt", "Dropper with a drop of liquid and a cancel symbol");
$("img[src=\"//sipsclub.com/cdn/shop/files/scientist_and_mom.png?v=1777116370&width=300\"]").attr("alt", "Scientist in goggles holding beaker");
$("img[src=\"//sipsclub.com/cdn/shop/files/sugar_free_2b5614de-3e9e-4ac0-8d59-ed00d3961cea.png?v=1777116453&width=300\"]").attr("alt", "Ice cubes with one crossed out");
$("img[src=\"//sipsclub.com/cdn/shop/files/gluten_free_fd6c3fed-4428-428e-b931-40cb8f447519.png?v=1777116153&width=300\"]").attr("alt", "Blue shopping bag with crossed out circle");

$('a[href="/products/veggie-sips-digestive-health"]').attr('aria-label','View product Veggie Sips Digestive Health');

$('a[href="/products/support-sips-energy-immunity"]').attr('aria-label','View product Support Sips Energy and Immunity');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/IMG_4364.png"]').attr('alt', 'Dr. Stuart B. Porter wearing stethoscope smiling and posing for a picture');

$('img[data-srcset*="//sipsclub.com/cdn/shop/files/Screenshot_2026-04-30_at_11.14.46_AM.png"]').attr('alt', 'Jessica Clayton in white coat smiling and posing for a picture');

$('img[data-srcset*="//sipsclub.com/cdn/shop/files/Screenshot_2026-04-30_at_11.19.48_AM.png"]').attr('alt', 'Anna Billeter in nurse dress wearing stethoscope smiling and posing for a picture');

$('img[data-srcset*="//sipsclub.com/cdn/shop/files/Katy_with_background_1.png"]').attr('alt', 'Founder Sipsclub Katt wearing white coat smiling and posing for a picture');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSClub-0326-478.jpg"]').attr('alt', 'Sips Club wellness drink packets inside an open cardboard box with start your sips routine promotional text');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSClub-0326-620.jpg"]').attr('alt', 'Sips Club Protein Sips peachy lime juice flavour front packaging');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSCLUB-163.jpg?v=1776898617"]').attr('alt', 'Sips Club Protein Sips peachy lime juice flavour front packaging');


$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSClub-0326-619.jpg"]').attr('alt', 'Sips Club Support Sips energy blend pouch front packaging');

$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSClub-0326-616.jpg"]').attr('alt', 'Sips Club Veggie Sips digestive drink blend pouch front packaging');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSCLUB-161.jpg?v=1776898563"]').attr('alt', 'Sips Club Veggie Sips digestive drink blend pouch front packaging');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/SIPSCLUB-020.jpg"]').attr('alt', 'Person holding Sips Club wellness drink pouches including Support Sips, Veggie Sips, and Protein Sips');


   $("img[src=\"//sipsclub.com/cdn/shop/files/protein_sips.jpg?v=1776976407&width=2048\"]").attr("alt", "Sips Club Protein Sips peachy lime packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/protein_3.jpg?v=1776976408&width=2048\"]").attr("alt", "Protein Sips bag with fruit and mesh bag");
    $("img[src=\"//sipsclub.com/cdn/shop/files/protein_4.jpg?v=1776976407&width=2048\"]").attr("alt", "Hand holding Sips Club protein powder bag");
    $("img[src=\"//sipsclub.com/cdn/shop/files/protein_2.jpg?v=1776976408&width=2048\"]").attr("alt", "Protein Sips bags in blue and white packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/protein_1.jpg?v=1776976408&width=2048\"]").attr("alt", "Peachy Lime supplement label with nutritional facts");
    $("img[src=\"//sipsclub.com/cdn/shop/files/3_612786cb-cb48-4757-a9c9-8e5b138c75de.png?v=1777063665&width=2048\"]").attr("alt", "Protein sips nutrition facts icons");
    $("img[src=\"//sipsclub.com/cdn/shop/files/protein_sips_supplement_facts_dfd02b5d-cc17-491a-a836-08346c437bb4.png?v=1777063661&width=2048\"]").attr("alt", "Supplement facts label with detailed nutritional information");

     $("img[src=\"//sipsclub.com/cdn/shop/files/veggie_sips_1.jpg?v=1776971493&width=2048\"]").attr("alt", "Veggie Sips digestive drink blend packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/veggie_sips_2.jpg?v=1776971493&width=2048\"]").attr("alt", "Digestive drink mix label with natural ingredients and dietary benefits");
    $("img[src=\"//sipsclub.com/cdn/shop/files/veggie_sips_3.jpg?v=1776971493&width=2048\"]").attr("alt", "Veggie Sips packaging with vegetables in a shopping basket");
    $("img[src=\"//sipsclub.com/cdn/shop/files/veggie_sips_4.jpg?v=1776971493&width=2048\"]").attr("alt", "Blue lunchbox with sandwich, blackberries, and vegetables along with veggie sips");
    $("img[src=\"//sipsclub.com/cdn/shop/files/veggie_sips_6.jpg?v=1776971494&width=2048\"]").attr("alt", "Veggie Sips digestive drink blend packaging with pineapple and bag");
    $("img[src=\"//sipsclub.com/cdn/shop/files/5_09599f10-224a-4d2f-9845-3cb1885754e7.png?v=1777063661&width=2048\"]").attr("alt", "Veggie sips logo with six icons highlighting product features");
    $("img[src=\"//sipsclub.com/cdn/shop/files/veggie_sips_supplement_facts.png?v=1777063662&width=2048\"]").attr("alt", "Supplement facts label with nutritional information");
    $("img[src=\"//sipsclub.com/cdn/shop/files/3.jpg?v=1777065348&width=2048\"]").attr("alt", "Veggie Sips digestive drink blend packaging");

     $("img[src=\"//sipsclub.com/cdn/shop/files/support_sips_1.jpg?v=1776970662&width=2048\"]").attr("alt", "Sips club energy blend supplement bag");
    $("img[src=\"//sipsclub.com/cdn/shop/files/support_sips_5.jpg?v=1776970662&width=2048\"]").attr("alt", "Pink bag of energy blend supplement with white text and icons");
    $("img[src=\"//sipsclub.com/cdn/shop/files/support_sips_2.jpg?v=1776970662&width=2048\"]").attr("alt", "Strawberries in green containers with pink supplement packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/support_sips_3.jpg?v=1776970662&width=2048\"]").attr("alt", "Sips Club drink packets on a beige tote bag");
    $("img[src=\"//sipsclub.com/cdn/shop/files/support_sips_4.jpg?v=1776970662&width=2048\"]").attr("alt", "Sips Club supplement packet and bag with limes");
    $("img[src=\"//sipsclub.com/cdn/shop/files/1_87375074-a49a-4890-89b0-ac2edcfecea2.png?v=1777063706&width=2048\"]").attr("alt", "Support sips benefits");
    $("img[src=\"//sipsclub.com/cdn/shop/files/support_sips_supplement_facts.png?v=1777063706&width=2048\"]").attr("alt", "Supplement facts label with nutrition information");
$('img[src="//sipsclub.com/cdn/shop/files/3.jpg?v=1777065348&width=2048"]').attr('alt', 'Veggie Sips customer testimonial');

     $("img[src=\"//sipsclub.com/cdn/shop/files/green_apple_1.jpg?v=1776968296&width=2048\"]").attr("alt", "Green apples with Sips Club green apple flavor packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/green_apple_2.jpg?v=1776968296&width=2048\"]").attr("alt", "Green apples and Sips Club packets on and around a green crate");

      $("img[src=\"//sipsclub.com/cdn/shop/files/blackberrybreeze.jpg?v=1777388341&width=2025\"]").attr("alt", "MiraQle blackberry breeze veggie chips packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/blackberry_twist_1.jpg?v=1776969650&width=2048\"]").attr("alt", "Blackberries with Sips Club digestive supplement packet");
    $("img[src=\"//sipsclub.com/cdn/shop/files/blackberry_twist_2.jpg?v=1776969650&width=2048\"]").attr("alt", "Fresh blackberries spilling from a white colander with a sips club packet");

      $("img[src=\"//sipsclub.com/cdn/shop/files/pinkpineapple.jpg?v=1777388360&width=2025\"]").attr("alt", "Sipology veggie sips pink pineapple packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/pink_pineapple_1.jpg?v=1776969932&width=2048\"]").attr("alt", "Pineapple and sips club packaging");
    $("img[src=\"//sipsclub.com/cdn/shop/files/pink_pineapple_2.jpg?v=1776969932&width=2048\"]").attr("alt", "Pineapple and spinach with Sips club pineapple packaging");

    $("img[src=\"//sipsclub.com/cdn/shop/files/watermelon_twist_1.jpg?v=1776969434&width=2048\"]").attr("alt", "Veggie Sips digestive drink blend packaging and sample stick");
    $("img[src=\"//sipsclub.com/cdn/shop/files/watermelon_wave_2.jpg?v=1776969159&width=2048\"]").attr("alt", "Watermelons and veggie sip packets");

     $("img[src=\"//sipsclub.com/cdn/shop/files/strawberry_spark_2.jpg?v=1776968972&width=2048\"]").attr("alt", "Strawberry flavored sips products surrounded by strawberries");
    $("img[src=\"//sipsclub.com/cdn/shop/files/strawberry_spark_1.jpg?v=1776968973&width=2048\"]").attr("alt", "Strawberry flavored drink mix packet on fresh strawberries");

     $("img[src=\"//sipsclub.com/cdn/shop/files/cherry_1.jpg?v=1776967728&width=2048\"]").attr("alt", "Sips club Cherry Charge flavour packet surrounded by cherries");
    $("img[src=\"//sipsclub.com/cdn/shop/files/cherry_2.jpg?v=1776967728&width=2048\"]").attr("alt", "Cherry-flavored drink and cherries in a fridge along with support sips cherry charge package");
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/IMG_2056.jpg"]').attr('alt', 'Katy & Kath smiling and posing together indoors during their teenage years');

$('img[data-srcset*="//sipsclub.com/cdn/shop/files/About_Us_Katy_and_Kath.png"]').attr('alt', 'Katy & Kath sitting together holding a Sips Club wellness drink gift box and smiling outdoors');
$('img[data-srcset*="//sipsclub.com/cdn/shop/files/kaths_sips_routine_1.png"]').attr('alt', 'Kathleen holding a Sips Club Lime Time wellness drink stick pack while smiling in the background');

$('img[data-srcset*="//sipsclub.com/cdn/shop/files/Kath_and_Katy_Support_1.png"]').attr('alt', 'Katy and Kath sitting together smiling and holding Sips Club wellness drinks');
$('img[srcset*="//sipsclub.com/cdn/shop/files/Sips_Logotype_Lockup_3x_4cde3504-2c51-44ff-bec6-325b18d0b5a5.png"]').attr('alt', 'Sips Club logo');
console.log("ready");
});